// extracted by mini-css-extract-plugin
module.exports = {"main":"AppNotificationBanner_main__YYaZ3","mainWrapper":"AppNotificationBanner_mainWrapper__RU098"};